import * as React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

interface IFieldInfoIconProps {
    title: string;
    content: string;
}

const FieldInfoIcon = (props: IFieldInfoIconProps) => {
    const popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={props.title}>
            {props.content}
        </Popover>
    );

    return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}>
            <i className="popover-icon material-icons md-18">info_outline</i>
        </OverlayTrigger>
    );
};

export default FieldInfoIcon;
